import React from 'react';

const BrandsPage = () => {
  const brands = [
    {
      name: 'LG',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/LG_logo_%282015%29.svg/200px-LG_logo_%282015%29.svg.png',
      services: 'AC, Refrigerator, Washing Machine, Microwave'
    },
    {
      name: 'Samsung',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Samsung_Logo.svg/200px-Samsung_Logo.svg.png',
      services: 'AC, Refrigerator, Washing Machine, Microwave'
    },
    {
      name: 'Whirlpool',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Whirlpool_logo.svg/200px-Whirlpool_logo.svg.png',
      services: 'Refrigerator, Washing Machine, Microwave'
    },
    {
      name: 'Godrej',
      logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/5/55/Godrej_Logo.svg/200px-Godrej_Logo.svg.png',
      services: 'AC, Refrigerator, Washing Machine'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Brands We Service</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Expert repair services for all major appliance brands
          </p>
        </div>
      </section>

      {/* Brands Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8"
                data-testid={`brand-card-${brand.name.toLowerCase()}`}
              >
                <div className="flex flex-col items-center text-center">
                  {/* Brand Logo */}
                  <div className="h-24 flex items-center justify-center mb-6">
                    <h2 className="text-4xl font-bold text-gray-800">{brand.name}</h2>
                  </div>

                  {/* Services */}
                  <div className="w-full">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Services Available:</h3>
                    <p className="text-gray-700">{brand.services}</p>
                  </div>

                  {/* CTA */}
                  <div className="mt-6 w-full">
                    <a
                      href={`https://wa.me/918655557727?text=${encodeURIComponent(`Hi, I need service for my ${brand.name} appliance.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-bold text-center transition-colors duration-200"
                      data-testid={`brand-whatsapp-${brand.name.toLowerCase()}`}
                    >
                      💬 WhatsApp for {brand.name} Service
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Other Brands? We Service Them Too!
            </h2>
            <p className="text-gray-700 text-lg mb-8">
              While we specialize in LG, Samsung, Whirlpool, and Godrej, we also service many other brands. 
              Call us to check if we can help with your specific appliance brand.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg">
              <p className="text-gray-800 font-medium">
                🔧 <strong>All Types of Appliances:</strong> Window AC, Split AC, Single Door Fridge, 
                Double Door Fridge, Top Load Washing Machine, Front Load Washing Machine, Microwave Ovens
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Book Service for Your Brand
          </h2>
          <p className="text-lg mb-8 text-blue-100 max-w-2xl mx-auto">
            Professional service for all major appliance brands
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:8655557727"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="brands-cta-call"
            >
              📞 +91 8655557727
            </a>
            <a
              href="tel:7054773277"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="brands-cta-call-2"
            >
              📞  7054773277
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BrandsPage;
